import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db08acc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = {
  key: 0,
  class: "menuMobile"
}
const _hoisted_3 = { class: "headerMenu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleMobileMenu" }, "Minha conta", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"44px"} }, null, -1))
const _hoisted_6 = { class: "avatarUser" }
const _hoisted_7 = {
  key: 0,
  class: "emailBtnContainer"
}
const _hoisted_8 = { class: "emailUser" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "E-mail:", -1))
const _hoisted_10 = { class: "email" }
const _hoisted_11 = {
  key: 0,
  class: "sucessoSalvar"
}
const _hoisted_12 = {
  key: 0,
  class: "trocarSenhaform"
}
const _hoisted_13 = {
  key: 0,
  class: "errorSenhasDiferentes"
}
const _hoisted_14 = { class: "btnContainer" }
const _hoisted_15 = {
  key: 0,
  class: "erroSalvar"
}
const _hoisted_16 = { class: "logout_nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_ctx.$store.state.menuMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "showMenuUserMobile" }, {
          default: _withCtx(() => [
            (_ctx.showMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_v_icon, {
                      size: "x-large",
                      style: {"padding":"22px","width":"44px"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeMenu()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" mdi-window-close ")
                      ]),
                      _: 1
                    }),
                    _hoisted_4,
                    _hoisted_5
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.initials), 1)
                  ]),
                  _createVNode(_Transition, { name: "trocarSenha" }, {
                    default: _withCtx(() => [
                      (!_ctx.trocarSenha)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _hoisted_9,
                              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.user.email), 1)
                            ]),
                            _createVNode(_component_v_btn, {
                              class: "trocarSenha",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trocarSenha = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Trocar senha ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_Transition, { name: "fade" }, {
                              default: _withCtx(() => [
                                (_ctx.sucessoSalvar)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Senha salva com sucesso! "))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, { name: "trocarSenha" }, {
                    default: _withCtx(() => [
                      (_ctx.trocarSenha)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.senhaAtual,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.senhaAtual) = $event)),
                              label: "Senha Atual",
                              "append-inner-icon": _ctx.hideSenhaAtual ? 'mdi-eye' : 'mdi-eye-off',
                              "onClick:appendInner": _cache[3] || (_cache[3] = () => (_ctx.hideSenhaAtual = !_ctx.hideSenhaAtual)),
                              type: _ctx.hideSenhaAtual ? 'password' : 'text',
                              rules: _ctx.passOldRule,
                              dark: ""
                            }, null, 8, ["modelValue", "append-inner-icon", "type", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.novaSenha,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.novaSenha) = $event)),
                              label: "Nova Senha",
                              "append-inner-icon": _ctx.hideNovaSenha ? 'mdi-eye' : 'mdi-eye-off',
                              "onClick:appendInner": _cache[5] || (_cache[5] = () => (_ctx.hideNovaSenha = !_ctx.hideNovaSenha)),
                              type: _ctx.hideNovaSenha ? 'password' : 'text',
                              rules: _ctx.passwordRules,
                              dark: ""
                            }, null, 8, ["modelValue", "append-inner-icon", "type", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.confirmarNovaSenha,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmarNovaSenha) = $event)),
                              label: "Confirmar nova senha",
                              "append-inner-icon": 
                _ctx.hideConfirmarSenha ? 'mdi-eye' : 'mdi-eye-off'
              ,
                              "onClick:appendInner": _cache[7] || (_cache[7] = 
                () => (_ctx.hideConfirmarSenha = !_ctx.hideConfirmarSenha)
              ),
                              type: _ctx.hideConfirmarSenha ? 'password' : 'text',
                              "hide-details": "",
                              dark: ""
                            }, null, 8, ["modelValue", "append-inner-icon", "type"]),
                            (_ctx.errorSenhasDiferentes)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " As senhas não correspondem! "))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_v_btn, {
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.trocarSenha = false)),
                                class: "btnCancelar"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Cancelar ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_btn, {
                                class: "btnSalvar",
                                onClick: _ctx.salvarSenha,
                                loading: _ctx.salvarSenhaLoading,
                                disabled: 
                  _ctx.errorSenhasDiferentes || _ctx.faltaCampo || _ctx.erroRegraSenha
                
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Salvar ")
                                ]),
                                _: 1
                              }, 8, ["onClick", "loading", "disabled"])
                            ]),
                            _createVNode(_Transition, { name: "fade" }, {
                              default: _withCtx(() => [
                                (_ctx.erroSalvar)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Ocorreu um erro ao salvar a senha. Verifique se a senha atual está correta e tente novamente. "))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_v_icon, {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.logout()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-logout")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.logout()))
                    }, "Sair")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}